module.exports = __webpack_public_path__ + "img/voucher_ticket.7ad5c977.png";